import * as Yup from 'yup';
import Translator from '../../core/i18n';
import { IValidation } from '../components/validation-props';
import { DefaultValidation } from './main-validations';


const T = Translator.create();

const RegExpDate = /^[0-9]{2}.[0-9]{2}.[0-9]{4}$/;
const RegExpTime = /^$|^(([01][0-9])|(2[0-3])):[0-5][0-9]$/;
const RegExpDateRange = /^[0-9]{2}.[0-9]{2}.[0-9]{4}[" "][-][" "][0-9]{2}.[0-9]{2}.[0-9]{4}$/;

export function getValidation(props?: IValidation) {
    const defaultValidation = new DefaultValidation(props);
    return Yup.object().shape({
        defaultValuesFormik: defaultValidation.SetDefaultValues(),
        isFileUploadEmpty: defaultValidation.GetIsFileUploadEmpty(),
        name: defaultValidation.GetName(),
        fileUploaded: defaultValidation.GetFileUploaded(),
        activityBeginDate: defaultValidation.GetActivityBeginDate(),
        activityBeginTime: defaultValidation.GetActivityBeginTime(),
        activityEndDate: defaultValidation.GetActivityEndDate(),
        activityEndTime: defaultValidation.GetActivityEndTime(),
        datePrerequisiteActivityId: defaultValidation.GetDatePrerequisiteActivityId(),
        selectActivity: defaultValidation.GetSelectActivity(),
        grade: defaultValidation.GetGrade(),
        isCommon: defaultValidation.GetIsCommon(),
        selectedClass: defaultValidation.GetSelectedClass(),
        activityTime: defaultValidation.GetActivityTime(),
        completionCriteria: defaultValidation.GetCompletionCriteria(),
        elessonType: defaultValidation.GetELessonType(),
        prerequisiteActivityId: defaultValidation.GetPrerequisiteActivityId(),
    });
}
